export default __webpack_public_path__ + "static/media/T13C.45525e61.png";